import {
  createAuthorizedHeaders,
  fetchAwsApi,
  getApiErrorMessage,
  parseApiResponse,
} from '../security';

export type ShoppingCartMutationMethod = 'PATCH' | 'DELETE';

interface ShoppingCartMutationInput {
  accountId: string;
  authenticated: boolean;
  cartItemId: string;
  method: ShoppingCartMutationMethod;
  quantity?: number;
}

export function buildShoppingCartQueuePayload(input: ShoppingCartMutationInput) {
  return {
    queue: 'shopping_cart',
    method: input.method,
    ...(input.authenticated
      ? { account_id: input.accountId }
      : { session_id: input.accountId }),
    cart_item_id: input.cartItemId,
    ...(input.method === 'PATCH' ? { quantity: input.quantity } : {}),
  };
}

export async function enqueueShoppingCartMutation(input: ShoppingCartMutationInput) {
  const response = await fetchAwsApi('/api/enqueue_tasks', {
    method: 'POST',
    headers: createAuthorizedHeaders({
      'Content-Type': 'application/json',
      ...(!input.authenticated ? { 'X-Session-ID': input.accountId } : {}),
    }),
    body: JSON.stringify(buildShoppingCartQueuePayload(input)),
  });
  const payload = await parseApiResponse(response);

  if (!response.ok) {
    throw new Error(getApiErrorMessage(payload, 'Unable to queue this shopping cart update.'));
  }

  return payload as { queued?: boolean; queue?: string; message_id?: string };
}
